(function ($) {
  $('.block--vehicules').each(function () {
    var that = $(this);
    var navTab = that.find(".nav-tab");
    var carouselCat01Html = $("#tab-cat01 .slider").html();
    // var carouselCat02Html = $("#tab-cat02 .slider").html();
    // var carouselCat03Html = $("#tab-cat03 .slider").html();
    // var carouselCat04Html = $("#tab-cat04 .slider").html();
    // var carouselCat05Html = $("#tab-cat05 .slider").html();
    var settings = {
      init: false,
      spaceBetween: 0,
      slidesPerView: 1,
      allowTouchMove: true,
      loop: false,
      watchOverflow: true,
      breakpoints: {
        800: {
          spaceBetween: 40,
          slidesPerView: 2,
          // autoplay: false,
        }
      },
      observer: true,
      observeParents: true,
      // autoplay: {
      //   delay: 5000,
      //   disableOnInteraction: false,
      // },
      navigation: {
        nextEl: '.block--vehicules .tab .custom-button-next',
        prevEl: '.block--vehicules .tab .custom-button-prev',
      },
    };

    var carouselInit = $("#tab-cat01").find(".swiper-container");
    var mySwiperInit = new Swiper(carouselInit[0], settings);
    mySwiperInit.init();

    navTab.on("click", function (e) {
      e.preventDefault();

      if (!($(this).hasClass("active"))) {
        var link = $(this).attr("class").split(' ')[1];
        var target = $(this).attr("href");
        var activePane = that.find(".tab.active");

        navTab.removeClass("active");
        $(this).addClass("active");

        activePane.removeClass("show");
        setTimeout(function () {
          activePane.removeClass("active");
          $(target).addClass("active");

          setTimeout(function () {
            $(target).addClass("show");

            // Carousel
            var carousel = $(target).find(".swiper-container");
            if (carousel.length) {
              var mySwiper = new Swiper(carousel[0], settings);

              if (!carousel.hasClass('swiper-container-initialized')) {
                mySwiper.init();
              } else {
                if (link == "cat01") {
                  $(target).find(".slider").html(carouselCat01Html);
                }
                // } else if (link == "cat02") {
                //   $(target).find(".slider").html(carouselCat02Html);
                // } else if (link == "cat03") {
                //   $(target).find(".slider").html(carouselCat03Html);
                // } else if (link == "cat04") {
                //   $(target).find(".slider").html(carouselCat04Html);
                // } else if (link == "cat05") {
                //   $(target).find(".slider").html(carouselCat05Html);
                // }

                var carouselReload = $(target).find(".swiper-container");
                var mySwiperReload = new Swiper(carouselReload[0], settings);
                mySwiperReload.init();
              }
            }
          }, 100);
        }, 200);
      }
    });
  });
})(jQuery);
